module.exports = __webpack_public_path__ + "img/38465-004.e2700ca1.jpg";